
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import { reportsActions } from "@/store/reports/types";
import CaseReportObservation from "@/modules/reports/case/observations/CaseReportObservation.vue";

export default defineComponent({
  name: "CaseReportObservations",
  components: {
    CaseReportObservation,
  },
  props: {
    caseReportObservations: {
      type: Array,
      default: [],
    },
    caseId: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions("reportsModule", {
      initCaseObservations: reportsActions.INIT_CASE_OBSERVATIONS,
    }),
    handleObservationChange() {
      this.$emit("observationChange");
    },
  },
  created() {
    this.initCaseObservations();
  },
});
